import React from 'react'
import { Form, Select, Input, Radio } from 'antd'
// import { withApollo } from 'react-apollo'
import _get from 'lodash/get'
// import withProps from 'recompose/withProps'
// import _keyBy from 'lodash/keyBy'
// import ticketItemQuery from '~/App/graphql/queries/ticketItem.gql'
// import raceQuery from '~/App/graphql/queries/race.gql'
// import ImageUploader from '../ImageUploader'
import { inject, observer } from 'mobx-react'
import { FormattedMessage } from 'react-intl'
import bibNumber from '~/App/utils/bibNumber'
import localeGet from '~/App/utils/localeGet'
import moment from 'moment'
// import eventSettingsFragment from '~/App/graphql/fragments/eventSettings.gql'

const formItemLayout = {
  labelCol: { sm: { span: 10 }, xs: { span: 24 } },
  wrapperCol: { sm: { span: 14 }, xs: { span: 24 } }
}
const bankBrands = ['bbl', 'kbank', 'ktb', 'tmb', 'scb', 'citi', 'cimb', 'uob', 'bay', 'tbank', 'ibank', 'lhb']
@inject('i18n')
@Form.create()
@observer
class RefundRequestForm extends React.Component {
  render () {
    const { form, i18n: { locale }, registration } = this.props
    const { event } = registration
    const { getFieldDecorator, getFieldValue } = form
    const participants = _get(registration, 'participants', [])
    const refundRequests = _get(registration, 'refundRequests', [])
    const requestedTicketIds = refundRequests.map(r => r.ticketItemId)
    const tickets = []
    participants.forEach(p => {
      p.tickets.forEach(t => {
        if (!requestedTicketIds.includes(t._id)) {
          tickets.push({
            ...t,
            participant: p
          })
        }
      })
    })
    getFieldDecorator(`record.method`, {
      initialValue: 'transfer',
      rules: [{ required: true }]
    })
    getFieldDecorator(`record.eventId`, {
      initialValue: registration.eventId,
      rules: [{ required: true }]
    })
    getFieldDecorator(`record.registrationId`, {
      initialValue: registration._id,
      rules: [{ required: true }]
    })
    getFieldDecorator(`record.paymentId`, {
      initialValue: _get(registration, 'payment._id'),
      rules: [{ required: true }]
    })
    getFieldDecorator(`record.masterType`, {
      initialValue: 'Registration',
      rules: [{ required: true }]
    })
    getFieldDecorator(`record.masterId`, {
      initialValue: registration._id,
      rules: [{ required: true }]
    })
    
    const ticketItemDecorator = getFieldDecorator('record.ticketItemId', {
      rules: [{ required: true }],
      initialValue: tickets.length === 1 
        ? _get(tickets, [0, '_id'])
        : undefined
    })
    const ticketId = getFieldValue('record.ticketItemId')
    const ticket = tickets.find(t => t._id === ticketId)
    const options = _get(ticket, 'ticketType.settings.refundRequest.options', [])
      .filter(o => 
        moment().isBetween(
          _get(o, 'period.start'),
          _get(o, 'period.end')
        )
      )
    return <Form>
      <h3>{{ en: 'Cancellation & Refund Request', zh: 'Cancellation & Refund Request', th: 'การขอยกเลิกการสมัครและขอคืนเงิน' }[locale]}</h3>
      <Form.Item label={{ en: 'Participant', zh: 'Participant', th: 'ผู้เข้าแข่งขัน' }[locale]} {...formItemLayout} >
        {ticketItemDecorator(
          <Select>
            {tickets.map(t =>
              <Select.Option key={t._id}>
                [{bibNumber(t.number, _get(event, 'settings.ticket.numberDigits', 4))}] {' '}
                {_get(t, 'participant.profile.firstName')} {' '}
                {_get(t, 'participant.profile.lastName')}
              </Select.Option>
            )}
          </Select>
        )}
      </Form.Item>
      {ticketId && <Form.Item label={{ en: 'Refund Option', th: 'การขอคืนเงิน', zh: 'Refund Option' }[locale]} {...formItemLayout}>
        {getFieldDecorator('record.optionId', { rules: [{ required: true }] })(
          <Radio.Group>
            {options.map(o =>
              <Radio key={o._id} value={o._id}>
                <span style={{ whiteSpace: 'pre-line' }}>
                  {localeGet(o, 'name', locale)}
                </span>
              </Radio>  
            )}
          </Radio.Group>
        )}
      </Form.Item>}
      <Form.Item label={{ en: 'Bank', zh: 'Bank', th: 'ธนาคาร' }[locale]} {...formItemLayout} >
        {getFieldDecorator('record.data.transfer.bankAccount.brand', { rules: [{ required: true }] })(
          <Select>
            {bankBrands.map(brand =>
              <Select.Option key={brand} value={brand}>
                <FormattedMessage id={`app.banks.${brand}`} />
              </Select.Option>
            )}
          </Select>
        )}
      </Form.Item>
      <Form.Item label={{ en: 'Account Name', zh: 'Account Name', th: 'ชื่อบัญชี' }[locale]} {...formItemLayout} >
        {getFieldDecorator('record.data.transfer.bankAccount.name', { rules: [{ required: true }] })(
          <Input />
        )}
      </Form.Item>
      <Form.Item label={{ en: 'Account Number', zh: 'Account Number', th: 'เลขบัญชี' }[locale]} {...formItemLayout} >
        {getFieldDecorator('record.data.transfer.bankAccount.number', { rules: [{ required: true, len: 10, pattern: '^([0-9]){10}$', message: ({ en: 'Please 10 digits account number', zh: 'Please 10 digits account number', th: 'กรุณากรอกเลขบัญชี 10 ตัว (ตัวเลขเท่านั้น)' })[locale] }] })(
          <Input />
        )}
      </Form.Item>
    </Form>
  }
}

export default RefundRequestForm



// WEBPACK FOOTER //
// ./src/App/components/RefundRequestForm/RefundRequestForm.js